var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"employee-company-info-card__item"},[_c('div',{staticClass:"ion-icon"},[_c('ion-icon',{attrs:{"name":_vm.icon}})],1),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }